import { normalizeOutlet, outletMatchesProduct } from './outletDisplay';

function normalizeChatUrl(value) {
  const raw = String(value || '').trim();
  if (!raw) return null;
  if (/^https?:\/\//i.test(raw)) {
    return raw.replace(/^http:\/\//i, 'https://');
  }
  return `https://${raw}`;
}

function phoneToWaMe(phone) {
  let d = String(phone || '').replace(/\D/g, '');
  if (!d) return null;
  if (d.length === 10 && d.startsWith('0')) {
    d = `254${d.slice(1)}`;
  }
  if (d.length < 9 || d.length > 15) return null;
  return `https://wa.me/${d}`;
}

function chatUrlFromOutlet(outlet) {
  if (!outlet) return null;
  const fromChat = normalizeChatUrl(outlet.chatUrl);
  if (fromChat) return fromChat;
  const phone = outlet.contact?.phone || outlet.contact?.whatsapp || outlet.phone;
  return phoneToWaMe(phone);
}

/**
 * Resolve the store chat URL for a product listing using outlet records.
 * @param {object} product
 * @param {object[]} outlets - normalized outlet list from GET /api/outlets
 */
export function resolveStoreChatUrlForProduct(product, outlets = []) {
  const direct = String(product?.vendorChatUrl || product?.storeChatUrl || '').trim();
  if (direct) return normalizeChatUrl(direct);

  for (const outlet of outlets) {
    if (!outletMatchesProduct(outlet, product)) continue;
    const chat = chatUrlFromOutlet(outlet);
    if (chat) return chat;
  }

  const phone =
    product?.vendor?.contact?.phone ||
    product?.vendor?.contact?.whatsapp ||
    product?.vendor?.phone;
  return phoneToWaMe(phone);
}

export function normalizeOutletsForChatLookup(outlets) {
  return (outlets || []).map(normalizeOutlet);
}
